import { axios } from "@/client/libs/axios";
import { FilterUserType, UserWithSecrets } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import qs from "qs";

export const getFilterUser = async (
  isInternal: boolean,
  page?: number,
  filter?: FilterUserType | null,
) => {
  if (filter) {
    const user = await axios.get<
      { page: number; data: UserWithSecrets[] },
      AxiosResponse<{ page: number; data: UserWithSecrets[] }>
    >(`user`, {
      params: {
        page: page,
        isInternal: { equals: isInternal },
        ...filter,
      },
      paramsSerializer: (params) => {
        const filterParams = qs.stringify(params);
        sessionStorage.setItem("Current_list", filterParams);
        return filterParams;
      },
    });
    console.log(user);
    return user.data;
  }

  const user = await axios.get<
    { page: number; data: UserWithSecrets[] },
    AxiosResponse<{ page: number; data: UserWithSecrets[] }>
  >("/user", {
    params: {
      page: page,
      isInternal: { equals: isInternal },
    },
    paramsSerializer: (params) => {
      const filterParams = qs.stringify(params);
      sessionStorage.setItem("Current_list", filterParams);
      return filterParams;
    },
  });
  console.log(user);

  return user.data;
};

export const usefilterUser = (
  isInternal: boolean,
  page?: number,
  filter?: FilterUserType | null,
) => {
  const {
    data: filterUsers,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["filter-user", isInternal, page, filter],
    queryFn: () => getFilterUser(isInternal, page, filter),
  });

  return { filterUsers, error, isLoading };
};
